import { render, staticRenderFns } from "./ComparePanel.vue?vue&type=template&id=919b745a&scoped=true"
import script from "./ComparePanel.vue?vue&type=script&lang=js"
export * from "./ComparePanel.vue?vue&type=script&lang=js"
import style0 from "./ComparePanel.vue?vue&type=style&index=0&id=919b745a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "919b745a",
  null
  
)

export default component.exports